import React, { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import { useTranslation } from "react-i18next";
import moment from "moment";
import { fetchOrderStatusHistory } from "../../../api/api"; 
import "bootstrap/dist/css/bootstrap.min.css";
import order from "./order";


interface OrderHistoryEntry {
  date1: string;
  order_note: string;
  order_status: string;
  user: string;
  partyname: string; 
  billno: string;
  voice_note?: string;
}

const OrderHistory: React.FC = () => {
  
  const { t } = useTranslation();
  const { billNo } = useParams<{ billNo: string }>();
  console.log("billNo from params:", billNo);

  const [partyName, setPartyName] = useState("ABC Traders");
  const [history, setHistory] = useState<OrderHistoryEntry[]>([]);

  useEffect(() => {
    const loadHistory = async () => {
      try {
        const data = await fetchOrderStatusHistory(billNo || "");
        console.log(" Received history from API:", data); 
        setHistory(data);

        
        if (data.length > 0 && data[0].partyname) {
          setPartyName(data[0].partyname);
        }
      } catch (error) {
        console.error("Failed to load order status history:", error);
      }
    };

    loadHistory();
  }, [billNo]);

  return (
    <div className="page-wrapper">
      <div className="content container-fluid">
        {/* Heading */}
        <h4 className="mb-4">
          {t("orderHistory")} - {billNo}
        </h4>

        {/* Bill & Party Info */}
        <div className="row mb-4">
          <div className="col-md-6">
            <label className="form-label">{t("billNo")}</label>
            <div className="form-control">{billNo}</div>
          </div>
          <div className="col-md-6">
            <label className="form-label">{t("partyName")}</label>
            <div className="form-control">{partyName}</div>
          </div>
        </div>

        {/* Status History Table */}
        <div className="card">
          <div className="card-body">
            <h5 className="mb-3">{t("statusHistory") || "Status History"}</h5>
            <div className="table-responsive">
              <table className="table table-bordered table-striped">
                <thead>
                  <tr>
                    <th>{t("date")}</th>
                    <th>{t("note")}</th>
                    <th>{t("status")}</th>
                    <th>{t("user")}</th>
                     <th>{t("voiceNote")}</th>
                  </tr>
                </thead>
                <tbody>
                  {history.length > 0 ? (
                    console.log("history:",history),
                    history.map((entry, index) => (
                       console.log("entry_date:",entry.date1),
                       console.log("entry_status:",entry.order_status),
                       
                      <tr key={index}>
                        <td>{moment(entry.date1).format("DD-MM-YYYY HH:mm")}</td>
                        <td>{entry.order_note}</td>
                        <td>
                          <span
                              className={`badge ${
                                entry.order_status?.toLowerCase().replace(/\s+/g, "") === "pending"
                                  ? "bg-danger text-light"
                                  : entry.order_status?.toLowerCase().replace(/\s+/g, "") === "customerresponded"
                                  ? "bg-warning text-dark"
                                  : entry.order_status?.toLowerCase().replace(/\s+/g, "") === "responded"
                                  ? "bg-warning text-dark"
                                  : entry.order_status?.toLowerCase().replace(/\s+/g, "") === "invoiceissued"
                                  ? ""
                                  : entry.order_status?.toLowerCase().replace(/\s+/g, "") === "approved"
                                  ? ""
                                  : entry.order_status?.toLowerCase().replace(/\s+/g, "") === "onwork"
                                  ? ""
                                  : entry.order_status?.toLowerCase().replace(/\s+/g, "") === "completed"
                                  ? "bg-success text-light"
                                  : "bg-light text-dark"
                              }`}
                              style={
                                entry.order_status?.toLowerCase().replace(/\s+/g, "") === "onwork"
                                  ? { backgroundColor: "#fd7e14", color: "white" } 
                                  : entry.order_status?.toLowerCase().replace(/\s+/g, "") === "invoiceissued"
                                  ? { backgroundColor: "#0d6efd", color: "white" } 
                                  : entry.order_status?.toLowerCase().replace(/\s+/g, "") === "approved"
                                  ? { backgroundColor: "#66b2ff", color: "white" } 
                                  : {}
                              }
                            >
                              {entry.order_status || "Pending"}
                            </span>
                          </td>
                        <td>{entry.user}</td>
                        {/*Voice Note column */}
                        <td>
                            {entry.voice_note ? (
                              <audio
                                controls
                                src={`http://localhost:5000${entry.voice_note}`}  
                                style={{ display: "block", marginTop: "4px", maxWidth: "180px" }}
                              />
                            ) : (
                              "-"
                            )}
                      </td>
                      </tr>
                    ))
                  ) : (
                    <tr>
                      <td colSpan={4} className="text-center">
                        {t("noRecordsFound") || "No records found."}
                      </td>
                    </tr>
                  )}
                </tbody>
              </table>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default OrderHistory;
